import { lessonRequestModalActionTypes } from './Constants';

export function toggleLessonRequestModal(data) {
	return {
		type: lessonRequestModalActionTypes.TOGGLE_LESSON_REQUEST_MODAL,
		payload: { data },
	};
}

export function getBooksForLessons(data) {
	return {
		type: lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS,
		payload: { data },
	};
}

export function getBooksForLessonsSuccess(data) {
	return {
		type: lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS_SUCCESS,
		payload: { data },
	};
}

export function getBooksForLessonsError() {
	return {
		type: lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS_ERROR,
	};
}

export function addLessonRequest(data, callback) {
	return {
		type: lessonRequestModalActionTypes.ADD_LESSON_REQUEST,
		payload: { data, callback },
	};
}

export function addLessonRequestSuccess(data) {
	return {
		type: lessonRequestModalActionTypes.ADD_LESSON_REQUEST_SUCCESS,
		payload: { data },
	};
}

export function addLessonRequestError() {
	return {
		type: lessonRequestModalActionTypes.ADD_LESSON_REQUEST_ERROR,
	};
}

export function getLessonByChapter(data) {
	return {
		type: lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER,
		payload: { data },
	};
}

export function getLessonByChapterSuccess(data) {
	return {
		type: lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER_SUCCESS,
		payload: { data },
	};
}

export function getLessonByChapterError() {
	return {
		type: lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER_ERROR,
	};
}

export function getSubjects(data) {
	return {
		type: lessonRequestModalActionTypes.GET_SUBJECTS,
		payload: { data },
	};
}

export function getSubjectsSuccess(data) {
	return {
		type: lessonRequestModalActionTypes.GET_SUBJECTS_SUCCESS,
		payload: { data },
	};
}

export function getSubjectsError() {
	return {
		type: lessonRequestModalActionTypes.GET_SUBJECTS_ERROR,
	};
}

export function getAvailableSlots(data) {
	return {
		type: lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS,
		payload: { data },
	};
}

export function getAvailableSlotsSuccess(data) {
	return {
		type: lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS_SUCCESS,
		payload: { data },
	};
}

export function getAvailableSlotsError() {
	return {
		type: lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS_ERROR,
	};
}

export function clearState() {
	return {
		type: lessonRequestModalActionTypes.CLEAR_LESSON_REQUEST_MODAL_STATE,
	};
}
